import React from 'react';

const LicenseInformation = () => {
    return (
        <div>
            <h2>Library and License Information</h2>
            <p>This application is divided into two parts: Chrome Extension and Web Application.</p>
            
            <h3>Chrome Extension</h3>
            <p><strong>Frontend:</strong> Built using JavaScript and Chrome APIs (e.g., capturing screenshots, sending data to the server).</p>
            <p><strong>Backend:</strong> Python Flask for APIs, Google Cloud Bucket for storage, and Selenium for full-page screenshot capturing.</p>
            <ul>
                <li><a href="https://www.selenium.dev/documentation/en/">Selenium - Apache 2.0 License</a></li>
                <li><a href="https://flask.palletsprojects.com/en/2.0.x/">Flask - BSD License</a></li>
                <li><a href="https://cloud.google.com/storage">Google Cloud Storage - Google Terms of Service</a></li>
            </ul>
            
            <h3>Web Application</h3>
            <p><strong>Frontend:</strong> React D3 Tree for loading JSON data and React Graph for user journey maps.</p>
            <p><strong>Backend:</strong> Python Flask and various language models for response generation.</p>
            <ul>
                <li><a href="https://reactjs.org/">React - MIT License</a></li>
                <li><a href="https://github.com/bkrem/react-d3-tree">React D3 Tree - MIT License</a></li>
                <li><a href="https://github.com/recharts/recharts">React Graph - MIT License</a></li>
                <li><a href="https://flask.palletsprojects.com/en/2.0.x/">Flask - BSD License</a></li>
                <li><a href="https://openai.com/policies/">OpenAI GPT-4 - Proprietary License</a></li>
                <li><a href="https://cloud.google.com/gemini">Google Gemini Flash - Google Terms of Service</a></li>
                <li><a href="https://huggingface.co/">Hugging Face - Apache 2.0 License</a></li>
                <li><a href="https://langchain.com/">LangChain - MIT License</a></li>
            </ul>

            <p>Please refer to the official documentation of each library for more details on licensing.</p>
        </div>
    );
};

export default LicenseInformation;
